<div *transloco="let t; read: 'navigation.header'">
  <jow-banner [messages]="bannerMessages$ | async"></jow-banner>
  <header>
    <div class="row">
      <ul class="language-selection" aria-label="language selection">
        @for (lang of translateService.getAvailableLangs(); track lang) {
          <li>
            <a
              class="language"
              [class.active]="translateService.getActiveLang() === lang"
              (click)="selectedValue = lang; onLanguageChanged()"
              (keydown.enter)="selectedValue = lang; onLanguageChanged()"
              tabindex="0"
            >{{ lang | uppercase }}</a>
          </li>
        }
      </ul>
      <div class="fill"></div>
      <div class="gov">
        {{ t('gov') }}
        <a href="https://www.belgium.be" target="_blank">www.belgium.be<img src="assets/logo/logo-be.svg" alt="Federal logo" /></a>
      </div>
    </div>
    <div class="row">
      <a [href]="'https://justonweb.be/' + translateService.getActiveLang()">
        <img src="assets/logo/logo-{{ translateService.getActiveLang() }}.svg" alt="Justice logo" />
      </a>
      @if (environmentName) {
        <mat-chip-set>
          <mat-chip>{{ 'environment' | transloco }}: {{ environmentName }}</mat-chip>
        </mat-chip-set>
      }
      <div class="fill"></div>
    </div>
  </header>
</div>
